import { createApp, h } from 'vue';
import { Quasar } from 'quasar';
import NoticeDialog from '@/components/NoticeDialog.vue';

export function useNoticeDialog() {
    return (options: {
        title?: string;
        mainText?: string;
        mainTextStyle?: string,
        displaySubText?: string;
        buttonText?: string;
        cancelButtonText?: string;
        dogImage?: string;
        confirmColor?: string;
        bgImage?: string;
        persistent?: boolean;
        oopsImage?: string;
        themeStyle?: string;
        giftIcon?: boolean;
        networkNotice?: boolean;
        mainTitle?: string;
        networkErrorConfirm?: boolean;
    }) => {
        let componentInstance: any = null;
        let app: any = null;
        let div: any = null;
        
        const promise = new Promise<boolean>((resolve) => {
            // 检查是否在客户端环境
            if (typeof document === 'undefined') {
                console.warn('useNoticeDialog: document is not available (SSR)');
                resolve(false);
                return;
            }
            
            div = document.createElement('div');
            document.body.appendChild(div);

            app = createApp({
                render() {
                    return h(NoticeDialog, {
                        'ref': (el: any) => {
                            if (el) componentInstance = el;
                        },
                        'modelValue': true,
                        'persistent': options.persistent ?? true,
                        'displayTitle': options.title,
                        'mainTitle': options.mainTitle,
                        'mainText': options.mainText,
                        'mainTextStyle': options.mainTextStyle,
                        'displaySubText': options.displaySubText,
                        'displayButtonText': options.buttonText,
                        'cancelButtonText': options.cancelButtonText,
                        'dogImage': options.dogImage,
                        'confirmColor': options.confirmColor,
                        'bgImage': options.bgImage,
                        'oopsImage':options.oopsImage,
                        'themeStyle':options.themeStyle,
                        'giftIcon': options.giftIcon,
                        'networkNotice': options.networkNotice,
                        'networkErrorConfirm': options.networkNotice,
                        // 监听确认/取消
                        'onConfirm': () => {
                            resolve(true);
                            app.unmount();
                            div.remove();
                        },
                        'onCancel': () => {
                            resolve(false);
                            app.unmount();
                            div.remove();
                        },
                        'onUpdate:modelValue': (val: boolean) => {
                            if (!val) {
                                // unmount 已在 confirm/cancel 中处理，防止重复
                                try {
                                    app.unmount();
                                } catch (e) {}
                                if (div.parentNode) div.remove();
                            }
                        },
                    });
                },
            });

            // **关键**：注册 Quasar 插件到这个临时 app
            app.use(Quasar, {});

            app.mount(div);
        });
        
        // 🔄 添加 update 方法
        (promise as any).update = (updateOptions: Partial<typeof options>) => {
            if (componentInstance && typeof componentInstance.updateContent === 'function') {
                // 调用组件暴露的 updateContent 方法
                componentInstance.updateContent({
                    displayTitle: updateOptions.title,
                    mainTitle: updateOptions.mainTitle,
                    mainText: updateOptions.mainText,
                });
            }
        };
        
        // 🚫 添加 hide 方法
        (promise as any).hide = () => {
            try {
                // 方案1：尝试调用组件的关闭方法
                if (componentInstance && typeof componentInstance.handleCancel === 'function') {
                    componentInstance.handleCancel();
                    return;
                }
                
                // 方案2：直接卸载应用
                if (app) {
                    try {
                        app.unmount();
                    } catch (e) {
                        console.warn('Failed to unmount app:', e);
                    }
                }
                if (div && div.parentNode) {
                    div.remove();
                }
            } catch (e) {
                console.warn('Failed to hide dialog:', e);
            }
        };
        
        return promise;
    };
}
